export default "__VITE_ASSET__SbgptNqp__"